module.exports = __webpack_public_path__ + "img/official_account.e6088801.jpg";